import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';
import Button from '../Parts/Button'

import DialogModal from './DialogModal';

const styles = theme => ({
  text: {
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },

  button: {
    background: '#F03A47',
    '&:hover::before': {
      backgroundColor: '#F03A47',
      opacity: .6,
    }
  }
});

class DeleteDialog extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (this.props.isDeleting && !nextProps.isDeleting) {
      this.props.toggleDialog();
    }
  }

  handleRemove = () => {
    this.props.remove();
  }

  render() {
    const { classes, isOpen, toggleDialog, title } = this.props;

    return (
      <DialogModal
        title={title}
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
      >
        <Grid container alignItems="center" direction="column" justify="center">
          <Grid item>
            <Typography variant="body1" className={classes.text}>
              この操作は元に戻せません。削除してよろしいですか？
            </Typography>
          </Grid>
          <Grid item>
            <Button
              handleClickButton={this.handleRemove}
              text="削除"
              color="red"
              loading={this.props.isDeleting}>
            </Button>
          </Grid>
        </Grid>
      </DialogModal>
    );
  }
}

DeleteDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  remove: PropTypes.func.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string,
  isDeleting: PropTypes.bool,
};

export default withStyles(styles)(DeleteDialog);



// WEBPACK FOOTER //
// ./src/components/common/DeleteDialog.jsx